<template>
    <r-e-dialog title="新建合同" class="layer-add-shops" :visible.sync="dialogVisible" :center="false" top="1vh"
                fullscreen @click-cancel="clickCancel">
        <div style="margin-bottom: 10px">
            <el-steps :active="active" simple>
                <el-step title="1.确定基本信息" icon="el-icon-circle-check"/>
                <el-step title="2.拟定合同" icon="el-icon-circle-check"/>
                <el-step title="3.缴纳保证金" icon="el-icon-circle-check"/>
                <el-step title="4.上传扫描原件" icon="el-icon-circle-check"/>
                <el-step title="5.签订成功" icon="el-icon-circle-check"/>
            </el-steps>
        </div>

        <div v-show="active===0">
            <div style="height: 700px;overflow: auto;">
                <el-form ref="basicInformation" label-position="left" label-width="100px" size="small" :model="contractData"
                         :rules="contractDataRules">
                    <div class="flex">
                        <div style="width: 49.5%;padding-left: 60px;margin: 20px 0;">

                            <div style="border-left: 5px #F5A623 solid;padding-left: 5px;margin: 10px 0;">承租人类型</div>

                            <el-form-item label="承租人类型">
                                <el-radio-group v-model="contractData.leasorType">
                                    <el-radio label="个人"/>
                                    <el-radio label="公司"/>
                                </el-radio-group>
                            </el-form-item>
                            <div class="flex" v-if="contractData.leasorType==='个人'">
                                <div style="width: 220px;margin-bottom: 18px" class="text-center">
                                    <div style="margin-bottom: 5px;">身份证正面</div>
                                    <upload-avatar @on-success="IdCardFrontSuccess" :uuid="contractData.idcardEmblem"/>
                                </div>
                                <div style="width: 220px;margin-bottom: 18px" class="text-center">
                                    <div style="margin-bottom: 5px;">身份证反面</div>
                                    <upload-avatar @on-success="IdCardReverseSideSuccess" :uuid="contractData.idcardFace"/>
                                </div>
                            </div>

                            <div class="flex" v-if="contractData.leasorType==='公司'">
                                <div style="width: 220px;margin-bottom: 18px" class="text-center">
                                    <div style="margin-bottom: 5px;">公司营业执照</div>
                                    <upload-avatar @on-success="businessLicenseSuccess" :uuid="contractData.businessLicense"/>
                                </div>
                                <div style="width: 220px;margin-bottom: 18px" class="text-center">
                                    <div style="margin-bottom: 5px;">法人身份证正面</div>
                                    <upload-avatar @on-success="IdCardFrontSuccess" :uuid="contractData.idcardEmblem"/>
                                </div>
                                <div style="width: 220px;margin-bottom: 18px" class="text-center">
                                    <div style="margin-bottom: 5px;">法人身份证反面</div>
                                    <upload-avatar @on-success="IdCardReverseSideSuccess" :uuid="contractData.idcardFace"/>
                                </div>
                            </div>

                            <el-form-item v-if="contractData.leasorType==='公司'" label="公司名称" prop="subCompanies">
                                <el-input v-model="contractData.subCompanies" style="width: 60%;"
                                          placeholder="请输入公司名称"/>
                            </el-form-item>

                            <el-form-item v-if="contractData.leasorType==='公司'" label="统一社会信用代码"
                                          prop="companiesSocialCreditCode">
                                <el-input v-model="contractData.companiesSocialCreditCode" style="width: 60%;"
                                          placeholder="请输入统一社会信用代码"/>
                            </el-form-item>

                            <el-form-item :label="contractData.leasorType==='个人'?'承租人姓名':'法人姓名'" prop="name">
                                <el-input v-model="contractData.name" style="width: 60%;" placeholder="请输入姓名"/>
                            </el-form-item>

                            <el-form-item label="手机号" prop="phone">
                                <el-input v-model="contractData.phone" style="width: 60%;" placeholder="请输入手机号"/>
                            </el-form-item>

                            <el-form-item label="身份证号" prop="idcard">
                                <el-input v-model="contractData.idcard" style="width: 60%;" placeholder="请输入身份证号"/>
                            </el-form-item>

                            <el-form-item label="身份证有效期" prop="idcardValidity">
                                <el-date-picker v-model="contractData.idcardValidity" type="date" style="width: 60%;"
                                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="请选择身份证有效期"/>
                            </el-form-item>

                            <el-form-item label="紧急联系人" prop="contactName">
                                <el-input v-model="contractData.contactName" style="width: 60%;"
                                          placeholder="请输入紧急联系人"/>
                            </el-form-item>

                            <el-form-item label="紧急联系人电话" prop="contactPhone">
                                <el-input v-model="contractData.contactPhone" style="width: 60%;"
                                          placeholder="请输入紧急联系人电话"/>
                            </el-form-item>
                        </div>

                        <div style="width: 49.5%;border-left: 1px #D7D7D7 solid;padding-left: 60px;margin: 20px 0;">
                            <div style="border-left: 5px #F5A623 solid;padding-left: 5px;margin: 10px 0;">店铺信息</div>
                            <el-form-item label="坐落">
                                <el-input v-model="contractData.shopAddress" style="width: 60%;" placeholder="请输入坐落"/>
                            </el-form-item>
                            <el-form-item label="建筑面积">
                                <el-input v-model="contractData.outArea" style="width: 60%;"
                                          placeholder="请输入建筑面积"/>
                            </el-form-item>
                            <el-form-item label="使用面积">
                                <el-input v-model="contractData.useArea" style="width: 60%;"
                                          placeholder="请输入使用面积"/>
                            </el-form-item>

                            <div style="border-left: 5px #F5A623 solid;padding-left: 5px;margin: 10px 0;">确认书信息</div>
                            <el-form-item label="项目竞标号" prop="biddingProjectName">
                                <el-input v-model="contractData.biddingProjectName" style="width: 60%;"
                                          placeholder="请输入项目竞标号"/>
                            </el-form-item>
                            <el-form-item label="成交时间" prop="biddingDate">
                                <el-date-picker v-model="contractData.biddingDate" type="date" style="width: 60%;"
                                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"/>
                            </el-form-item>
                            <el-form-item label="出价金额" prop="bidPrice">
                                <el-input v-model="contractData.bidPrice" type="number" style="width: 60%;"
                                          @blur="numberBlur" placeholder="请输入出价金额"/>
                                <!--<el-select v-model="contractData.biddingUuid" placeholder="请选择项目竞标号">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"/>
                                </el-select>-->
                            </el-form-item>
                            <el-form-item label="竞买号" prop="biddingNumber">
                                <el-input v-model="contractData.biddingNumber" style="width: 60%;"
                                          placeholder="请输入竞买号"/>
                                <!--<el-select v-model="contractData.biddingUuid" placeholder="请选择项目竞标号">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"/>
                                </el-select>-->
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="text-center">
                <el-button type="primary" @click="oneNextStep">下一步</el-button>
            </div>
        </div>

        <div v-show="active===1">
            <div style="height: 700px;overflow: auto;">
                <el-form ref="draftContract" label-position="left" label-width="110px" size="small" :model="contractData"
                         :rules="contractDataRules">
                    <div class="flex">
                        <div style="width: 40.5%;padding-left: 60px;margin: 20px 0;">
                            <el-form-item label="合同编号" prop="contractPcNumber">
                                <el-input v-model="contractData.contractPcNumber" style="width: 80%;" placeholder="请输入合同编号"/>
                            </el-form-item>
                            <el-form-item label="合同开始时间" prop="startDate">
                                <el-date-picker v-model="contractData.startDate" type="date" style="width: 80%;"
                                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"/>
                            </el-form-item>
                            <el-form-item label="合同结束时间" prop="endDate">
                                <el-date-picker v-model="contractData.endDate" type="date" style="width: 80%;"
                                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"/>
                            </el-form-item>
                            <el-form-item label="合同签订时间" prop="signContractDate">
                                <el-date-picker v-model="contractData.signContractDate" type="date" style="width: 80%;"
                                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"/>
                            </el-form-item>
                            <el-form-item label="合同类型" prop="contractType">
                                <el-radio-group v-model="contractData.contractType">
                                    <el-radio :label="1">城投自营</el-radio>
                                    <el-radio :label="2">其他</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="合同中型" prop="projectRentalType">
                                <el-radio-group v-model="contractData.projectRentalType">
                                    <el-radio :label="1">协议出租</el-radio>
                                    <el-radio :label="2">公开竞租</el-radio>
                                    <el-radio :label="3">其他</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="缴费方式" prop="paidBillType">
                                <el-radio-group v-model="contractData.paidBillType">
                                    <el-radio :label="1">微信代扣</el-radio>
                                    <el-radio :label="2">线下转账</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="经营项目" prop="purpose">
                                <el-input v-model="contractData.purpose" style="width: 80%;" placeholder="请输入经营项目"/>
                            </el-form-item>
                            <el-form-item label="履约保证金" prop="rentalDepositMonth">
                                <el-input type="number" v-model="contractData.rentalDepositMonth" placeholder="请输入月份"
                                          style="width: 25%;"/>
                                x
                                <el-input type="number" v-model="contractData.rentalDepositMonthAmount" placeholder="请输入月租标准"
                                          style="width: 30%;"/>
                                = {{ numberFormat(contractData.rentalDeposit) }}
                            </el-form-item>
                            <el-form-item label="水电保证金" prop="hydropowerDeposit">
                                <el-input type="number" v-model="contractData.hydropowerDeposit" style="width: 80%;"
                                          @blur="numberBlur" placeholder="请输入水电保证金"/>
                            </el-form-item>
                            <el-form-item label="消防保证金" prop="fireDeposit">
                                <el-input type="number" v-model="contractData.fireDeposit" style="width: 80%;"
                                          @blur="numberBlur" placeholder="请输入消防保证金"/>
                            </el-form-item>
                        </div>

                        <div style="width: 59%;border-left: 1px #D7D7D7 solid;padding-left: 30px;margin: 20px 0;">

                            <el-form-item label="装修期" prop="decorateMonthLength">
                                <el-select v-model="contractData.decorateMonthLength" style="width: 60%;"
                                           placeholder="请选择装修期">
                                    <el-option v-for="item in 10" :key="item" :label="(item-1)+'个月'" :value="item-1"/>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="合同归属" prop="contractAffiliationType">
                                <el-radio-group v-model="contractData.contractAffiliationType">
                                    <el-radio :label="1">城投自营</el-radio>
                                    <el-radio :label="2">其他</el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <el-form-item label="账单模式" prop="createBillType">
                                <el-radio-group v-model="contractData.createBillType">
                                    <el-radio :label="2">按季</el-radio>
                                    <el-radio :label="1">按月</el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <el-form-item label="办理模式" prop="conductionModeType">
                                <el-radio-group v-model="contractData.conductionModeType">
                                    <el-radio :label="1">移动端</el-radio>
                                    <el-radio :label="2">线下办理</el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <div style="border-left: 5px #F5A623 solid;padding-left: 5px;margin: 10px 0;">租金信息</div>

                            <div style="border: 1px solid #F1F1F3;">
                                <r-e-table ref="tableUNRef" :data="contractData.shopContractPayBillGrowthRates"
                                           :key="randomKey" :columns="[]" @cell-click="editData"
                                           :height="400" :showPagination="false">
                                    <el-table-column label="租金类型" prop="rentalDetail">
                                        <template slot-scope="{ row,column,column:{property}}">
                                            <el-input v-if="row[property + 'isShow']" size="mini" :ref="property"
                                                      v-model="row[property]" @blur="alterData(row,column)"/>
                                            <span v-else>{{ row[property] }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="计租面积(㎡)" prop="meterRentArea" width="140">
                                        <template slot-scope="{ row,column,column:{property}}">
                                            <el-input v-if="row[property + 'isShow']" size="mini" :ref="property"
                                                      type="number" v-model="row[property]" @blur="alterData(row,column)"/>
                                            <span v-else>{{ row[property] }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="计租开始时间" prop="startDate" width="140">
                                        <template slot-scope="{ row,column,column:{property}}">
                                            <el-date-picker
                                                    style="width: 140px" v-if="row[property + 'isShow']" size="mini"
                                                    :ref="property" v-model="row[property]" @blur="alterData(row,column)"
                                                    type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                                    placeholder="选择日期"/>
                                            <span v-else>{{ row[property] }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="计租结束时间" prop="endDate" width="140">
                                        <template slot-scope="{ row,column,column:{property}}">
                                            <el-date-picker
                                                    style="width: 140px" v-if="row[property + 'isShow']" size="mini"
                                                    :ref="property" v-model="row[property]" @blur="alterData(row,column)"
                                                    type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                                    placeholder="选择日期"/>
                                            <span v-else>{{ row[property] }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="计租单价" prop="centiarePrice" width="140">
                                        <template slot-scope="{ row,column,column:{property}}">
                                            <el-input v-if="row[property + 'isShow']" size="mini" :ref="property"
                                                      type="number" v-model="row[property]" @blur="alterData(row,column)"/>
                                            <span v-else>{{ row[property] }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="年递增率" prop="yearGrowthRate" width="140">
                                        <template slot-scope="{ row,column,column:{property}}">
                                            <el-select v-if="row[property + 'isShow']" size="mini" filterable
                                                       :ref="property" v-model="row[property]" @change="alterData(row,column)">
                                                <el-option v-for="item in 11" :key="item" :label="(item-1)+'%'" :value="(item-1)"/>
                                            </el-select>
                                            <span v-else>{{ row[property] }}%</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="月租金" prop="monthAmount" width="140">
                                        <template slot-scope="{ row,column,column:{property}}">
                                            <el-input v-if="row[property + 'isShow']" size="mini" :ref="property"
                                                      type="number" v-model="row[property]" @blur="alterData(row,column)"/>
                                            <span v-else>{{ row[property] }}</span>
                                        </template>
                                    </el-table-column>
                                    <template slot="empty">
                                        <el-empty/>
                                    </template>
                                    <el-table-column slot="toolbar" label="操作" width="100">
                                        <template slot-scope="{ $index:index }">
                                            <div class="table-tools">
                                                <span class="table-btn" @click="addEditRent()"
                                                      v-if="contractData.shopContractPayBillGrowthRates.length===index+1">
                                                    添加租金
                                                </span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </r-e-table>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="text-center">
                <el-button type="primary" @click="active = 0">上一步</el-button>
                <el-button type="primary">保存</el-button>
                <el-button type="primary" @click="twoNextStep">下一步</el-button>
            </div>
        </div>

        <div v-show="active===2">
            <div style="height: 700px;overflow: auto;">
                <div style="border-left: 5px #F5A623 solid;padding-left: 5px;margin: 10px 0;">保证金</div>
                <div style="border: 1px solid #F1F1F3">
                    <el-button type="primary" size="small" @click="oneClickWriteOff">一键核销</el-button>
                    <r-e-table ref="tableUNRef" :data="depositList" :columns="depositColumns" :height="300"
                               :showPagination="false" @selection-change="handleSelectionChange">
                        <template slot="empty">
                            <el-empty/>
                        </template>
                        <el-table-column slot="toolbar" label="操作" width="100">
                            <template slot-scope="{ row }">
                                <div class="table-tools">
                                    <span class="table-btn" v-if="row.statusCode!==600602" @click="heXiao(row)">核销</span>
                                </div>
                            </template>
                        </el-table-column>
                    </r-e-table>
                </div>
            </div>
            <div class="text-center">
                <el-button type="primary" @click="active=1">上一步</el-button>
                <el-button type="primary">保存</el-button>
                <el-button type="primary" @click="exportContract">导出合同</el-button>
                <el-button type="primary" @click="threeNextStep">下一步</el-button>
            </div>
        </div>

        <div v-show="active===3">
            <div style="height: 700px;overflow: auto;">
                <el-form label-position="top" size="small">
                    <div class="flex justify-between">
                        <el-form-item label="上传合同扫码原件" class="text-center" style="width: 350px!important;">
                            <upload-picture-card :uuidList="imgList" :limit="24" @on-success="handleSuccess"
                                                 @on-remove="handleRemove"/>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="text-center">
                <el-button type="primary" @click="active=2">上一步</el-button>
                <el-button type="primary">保存</el-button>
                <el-button type="primary" @click="exportContract">导出合同</el-button>
                <el-button type="primary" @click="fourNextStep">下一步</el-button>
            </div>
        </div>

        <div v-show="active===4">
            <div style="height: 700px;overflow: auto;" class="flex align-center justify-center">
                <el-image :src="require('@images/shops/u49.png')"/>
            </div>
            <div class="text-center">
                <el-button type="primary" @click="active=3">上一步</el-button>
                <el-button type="primary" @click="clickCancel">完成</el-button>
            </div>
        </div>

        <layer-bill-hexiao ref="layerBillHexiao" @get-data="contractPaybill"/>
    </r-e-dialog>
</template>

<script>
    import uploadAvatar from "@/components/Upload/upload-avatar";
    import uploadPictureCard from "@/components/Upload/upload-picture-card";
    import { depositColumns } from '../../../data';
    import {timeFormat, numberFormat, ParseFloatFormat,ParseIntFormat} from "@custom/index";
    import {
        getLeasorDetail,
        signLeasor,
        signApartment,
        signContract,
        contractPaybill,
        contractPicture,
        contractExport
    } from '@/api/shops-lease';
    import {MessageInfo, MessageError, MessageSuccess} from "@custom/message";
    import {downloadByData} from "@/utils/hooks/download";
    export default {
        name: "layer-add-shops-contract",
        data() {
            return {
                dialogVisible: false,
                depositColumns,
                apartmentUuids: null,
                contractDataRules: {
                    subCompanies: [{required: true, message: '请输入公司名称', trigger: 'blur'}],
                    companiesSocialCreditCode: [{required: true, message: '请输入统一社会信用代码', trigger: 'blur'}],
                    name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
                    phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: '请输入正确的手机号码'},
                    ],
                    idcard: [
                        {required: true, message: '请输入身份证号', trigger: 'blur'},
                        {pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确的身份证'},
                    ],
                    idcardValidity: [{required: true, message: '请选择身份证有效期', trigger: 'change'}],
                    contactName: [{required: true, message: '请输入紧急联系人', trigger: 'blur'}],
                    contactPhone: [
                        {required: true, message: '请输入紧急联系人电话', trigger: 'blur'},
                        {pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: '请输入正确的手机号码'},
                    ],
                    biddingProjectName: [{required: true, message: '请输入项目竞标号', trigger: 'blur'}],
                    biddingDate: [{required: true, message: '请选择成交时间', trigger: 'change'}],
                    biddingNumber: [{required: true, message: '请输入竞买号', trigger: 'blur'}],
                    bidPrice: [{required: true, message: '请输入出价金额', trigger: 'blur'}],
                    contractPcNumber: [{required: true, message: '请输入合同编号', trigger: 'blur'}],
                    startDate: [{required: true, message: '请选择合同开始时间', trigger: 'change'}],
                    endDate: [{required: true, message: '请选择合同结束时间', trigger: 'change'}],
                    signContractDate: [{required: true, message: '请选择合同签订时间', trigger: 'change'}],
                    contractType: [{required: true, message: '请选择合同类型', trigger: 'change'}],
                    projectRentalType: [{required: true, message: '请选择合同中型', trigger: 'change'}],
                    paidBillType: [{required: true, message: '请选择缴费方式', trigger: 'change'}],
                    purpose: [{required: true, message: '请输入经营项目', trigger: 'blur'}],
                    rentalDepositMonth: [{required: true, message: '请输入月份', trigger: 'blur'}],
                    hydropowerDeposit: [{required: true, message: '请输入水电保证金', trigger: 'blur'}],
                    fireDeposit: [{required: true, message: '请输入消防保证金', trigger: 'blur'}],
                    decorateMonthLength: [{required: true, message: '请选择装修期', trigger: 'change'}],
                    contractAffiliationType: [{required: true, message: '请选择合同归属', trigger: 'change'}],
                    conductionModeType: [{required: true, message: '请选择办理模式', trigger: 'change'}],
                    createBillType: [{required: true, message: '请选择账单模式', trigger: 'change'}],
                },
                active: 0,
                imgList: [],
                depositList: [],
                formDepositPublish: {},
                depositType: null,
                randomKey: Math.random(),
                contractData: {
                    uuid: null,
                    shopContractUuid: null,                         //合同uuid
                    leasorUuid: null,                               //租户uuid
                    leasorType: '个人',                               //租户类型 个人 公司
                    idcardFace: null,                               //身份证人像面反面
                    idcardEmblem: null,                             //身份证国徽面正面
                    businessLicense: null,                          //营业执照
                    name: null,                                     //名字
                    idcard: null,                                   //身份证
                    phone: null,                                    //电话号码
                    contactName: null,                              // |string |紧急联系人 |
                    contactPhone: null,                             // |string | 紧急联系人电话 |
                    subCompanies: null,                             //所属公司名称
                    companiesSocialCreditCode: null,                //社会统一信用代码
                    idcardValidity: null,                           //身份证有效期
                    apartmentUuids: null,                           //房间uuid集合
                    biddingUuid: null,                              //竞标记录uuid
                    contractPcNumber: null,                         //管家pc手输合同号
                    startDate: null,                                // 合同开始时间
                    endDate: null,                                  // 合同结束时间
                    signContractDate: null,                         //合同签订时间
                    contractType: null,                             //合同类型 城投自营 、 其他
                    contractTypeName: null,                         //合同类型名称
                    projectRentalType: null,                        //合同中型  1协议出租、2公开竟组、3其他
                    projectRentalTypeName: null,                    //合同中型 名称 协议出租、公开竟组、其他
                    paidBillType: null,                             //缴费方式 微信代扣、线下转账
                    paidBillTypeName: null,                         //缴费方式名称
                    purpose: null,                                  //用途 经营项目
                    rentalDepositMonth: null,                       //履约保证金月数
                    rentalDepositMonthAmount:null,                  //履约保证金月金额
                    rentalDeposit: null,                            //租赁押金
                    hydropowerDeposit: null,                        //水电押金
                    fireDeposit: null,                              //消防押金
                    contractAffiliationType: null,                  //项目归属类型 合同归属
                    contractAffiliationTypeName: null,              //项目归属类型名称 城投自营 其他
                    conductionModeType: null,                       //办理模式
                    conductionModeTypeName: null,                   //办理模式名称 移动端、线下办理
                    shopContractPayBillGrowthRates: [],
                    contractPictures: null,                         //合同照片
                    decorateMonthLength: null,                      //装修月份
                    apartmentSetUuid: null,
                    outArea: null,
                    shopAddress: null,
                    useArea: null,
                    createBillType: null,                           //账单模式类型 1按月 2按季
                    createBillTypeName: null,                       //账单模式类型 按月 按季
                    biddingProjectName: null,
                    biddingDate: null,
                    biddingNumber: null,
                    bidPrice: null,
                },
                loadingOptions: {
                    lock: true,
                    text: "Loading...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                },
                multipleSelection: [],
            };
        },
        components: {
            uploadAvatar, uploadPictureCard,
            layerBillHexiao: () => import("./layer-bill-hexiao")
        },
        methods: {

            async openDialog(data) {
                console.log(data);
                let {uuid = ''} = data;
                let uuids = uuid.split(";").filter(i => i !== '');
                if (uuids.length > 0) {
                    this.apartmentUuids = uuids;
                    await this.signApartment();
                } else MessageInfo("请选择商铺");
            },

            async signApartment(){
                let that = this;
                let loadingOptions = that.loadingOptions;
                const loading = that.$loading({...loadingOptions});
                let apartmentUuids = that.apartmentUuids;
                let res = await signApartment({apartmentUuids: [...apartmentUuids]}).catch(err => loading.close());
                if (res) {
                    loading.close();
                    let {info: {outArea, shopAddress, useArea, uuid}} = res;
                    that.contractData.apartmentSetUuid = uuid;
                    that.contractData.outArea = outArea;
                    that.contractData.shopAddress = shopAddress;
                    that.contractData.useArea = useArea;
                    this.active = 0;
                    this.dialogVisible = true;
                }
            },

            handleSuccess({fileList}) {
                this.imgList = fileList.map(item => {
                    let {name, response} = item;
                    let resOk = response && typeof (response) !== undefined;
                    if (resOk) {
                        let {returnObject: {info: {uuid}}} = response;
                        return uuid;
                    } else {
                        return name;
                    }
                });
            },

            handleRemove({fileList}) {
                this.imgList = fileList.map(item => {
                    let {name, response} = item;
                    let resOk = response && typeof (response) !== undefined;
                    if (resOk) {
                        let {returnObject: {info: {uuid}}} = response;
                        return uuid;
                    } else return name;

                });
            },
            //身份证正面上传回调
            IdCardFrontSuccess({info: {uuid}}) {
                // 上传图片
                this.contractData.idcardEmblem = uuid;
            },
            //身份证反面上传回调
            IdCardReverseSideSuccess({info: {uuid}}) {
                // 上传图片
                this.contractData.idcardFace = uuid;
            },
            //营业执照上传回调
            businessLicenseSuccess({info: {uuid}}) {
                // 上传图片
                this.contractData.businessLicense = uuid;
            },

            oneNextStep() {
                let that = this;
                // 表单提交
                this.$refs["basicInformation"].validate((valid) => {
                    if (valid) {
                        let {
                            leasorUuid, name, phone, idcard, subCompanies, leasorType, idcardFace, idcardEmblem,
                            businessLicense, contactName, contactPhone, companiesSocialCreditCode, idcardValidity,
                            apartmentSetUuid, biddingProjectName, biddingDate, biddingNumber, bidPrice
                        } = that.contractData;
                        if (leasorType === '公司') {
                            if (businessLicense === null || businessLicense === ''){
                                MessageInfo("请上传营业执照");
                                return;
                            }
                        }
                        if (idcardFace === null || idcardFace === ''){
                            MessageInfo("请上传身份证反面");
                            return;
                        }
                        if (idcardEmblem === null || idcardEmblem === ''){
                            MessageInfo("请上传身份证正面");
                            return;
                        }
                        bidPrice = parseInt((bidPrice * 100).toFixed(0));
                        let data = {
                            leasorUuid, name, phone, idcard, subCompanies, leasorType, idcardFace, idcardEmblem,
                            businessLicense, contactName, contactPhone, companiesSocialCreditCode, idcardValidity,
                            apartmentSetUuid, biddingProjectName, biddingDate, biddingNumber, bidPrice
                        };
                        let loadingOptions = that.loadingOptions;
                        const loading = that.$loading({...loadingOptions});
                        signLeasor(data).then(res => {
                            let {info: {biddingUuid}} = res;
                            that.contractData.biddingUuid = biddingUuid;
                            that.contractData.shopContractPayBillGrowthRates = [{
                                meterRentArea: "0.00",
                                centiarePrice: "0.00",
                                monthAmount: "0.00"
                            }];
                            loading.close();
                            that.active = 1;
                        }).catch(err => loading.close());
                    }
                });
            },

            twoNextStep() {
                let that= this;
                this.$refs["draftContract"].validate((valid) => {
                    if (valid) {
                        let {
                            leasorUuid, name, phone, idcard, subCompanies, leasorType, idcardFace, idcardEmblem,
                            businessLicense, contactName, contactPhone, companiesSocialCreditCode, idcardValidity,
                            apartmentSetUuid, contractPcNumber, startDate, endDate, contractType, contractTypeName,
                            projectRentalType, projectRentalTypeName, paidBillType, paidBillTypeName, purpose,
                            rentalDepositMonth, rentalDepositMonthAmount, rentalDeposit, hydropowerDeposit, fireDeposit,
                            contractAffiliationType, contractAffiliationTypeName, decorateMonthLength, createBillType,
                            createBillTypeName, conductionModeType, conductionModeTypeName, biddingUuid,
                            shopContractPayBillGrowthRates, uuid
                        } = that.contractData;
                        contractTypeName = contractType === 1 ? '城投自营' : '其他';
                        projectRentalTypeName = projectRentalType === 1 ? '协议出租' : projectRentalType === 2 ? '公开竟组' : '其他';
                        paidBillTypeName = paidBillType === 1 ? '微信代扣' : '线下转账';
                        rentalDepositMonthAmount = parseInt((rentalDepositMonthAmount * 100).toFixed(0));
                        rentalDeposit = parseInt((rentalDeposit * 100).toFixed(0));
                        hydropowerDeposit = parseInt((hydropowerDeposit * 100).toFixed(0));
                        fireDeposit = parseInt((fireDeposit * 100).toFixed(0));
                        contractAffiliationTypeName = contractAffiliationType === 1 ? '城投自营' : '其他';
                        createBillTypeName = createBillType === 1 ? '按月' : '按季';
                        conductionModeTypeName = conductionModeType === 1 ? '移动端' : '线下办理';
                        for (let item of shopContractPayBillGrowthRates) {
                            item.centiarePrice = ParseIntFormat(item.centiarePrice);
                            item.monthAmount = ParseIntFormat(item.monthAmount);
                            item.meterRentArea = parseFloat(item.meterRentArea || 0);
                        }
                        let data = {
                            leasorUuid, name, phone, idcard, subCompanies, leasorType, idcardFace, idcardEmblem,
                            businessLicense, contactName, contactPhone, companiesSocialCreditCode, idcardValidity,
                            apartmentSetUuid, contractPcNumber, startDate, endDate, contractType, contractTypeName,
                            projectRentalType, projectRentalTypeName, paidBillType, paidBillTypeName, purpose,
                            rentalDepositMonth, rentalDepositMonthAmount, rentalDeposit, hydropowerDeposit,
                            fireDeposit, contractAffiliationType, contractAffiliationTypeName, decorateMonthLength,
                            createBillType, createBillTypeName, conductionModeType, conductionModeTypeName, biddingUuid,
                            shopContractPayBillGrowthRates, uuid
                        };
                        let loadingOptions = that.loadingOptions;
                        const loading = that.$loading({...loadingOptions});
                        signContract(data).then(res => {
                            let {info: {uuid}} = res;
                            that.contractData.uuid = uuid;
                            that.contractPaybill();
                            loading.close();
                            // that.active = 1;
                        }).catch(err => loading.close());
                    }
                });
            },

            contractPaybill() {
                let that = this;
                let {uuid}=this.contractData;
                let loadingOptions = that.loadingOptions;
                const loading = that.$loading({...loadingOptions});
                contractPaybill({uuid}).then(res => {
                    let {list} = res;
                    // console.log("list",list);
                    that.depositList = list;
                    loading.close();
                    this.active = 2;
                }).catch(err => loading.close());
            },

            heXiao(data) {
                let that = this;
                const {leasorUuid} = that.contractData;
                that.$refs["layerBillHexiao"].openDialog({leasorUuid, bills: [data]});
            },

            oneClickWriteOff() {
                let that = this;
                let multipleSelection = that.multipleSelection;
                const {leasorUuid} = that.contractData;
                that.$refs["layerBillHexiao"].openDialog({leasorUuid, bills: [...multipleSelection]});
            },

            threeNextStep() {
                let that = this;
                const depositList = that.depositList;
                const statusCodes = depositList.map(v=>v.statusCode);
                if (statusCodes.some(v => v === 600601)) {
                    MessageInfo("请核销全部账单");
                    return;
                }
                this.active = 3;
            },

            fourNextStep() {
                let that = this;
                let {uuid} = that.contractData;
                let imgList = that.imgList;
                if (imgList.length === 0) {
                    MessageInfo("请上传合同扫码原件");
                    return;
                }
                let loadingOptions = that.loadingOptions;
                const loading = that.$loading({...loadingOptions});
                const data = {shopContractUuid: uuid, contractPictures: imgList.join(";")};
                contractPicture(data).then(res => {
                    loading.close();
                    this.active = 4;
                }).catch(() => loading.close());
            },

            addEditRent() {
                this.contractData.shopContractPayBillGrowthRates.push({
                    meterRentArea: "0.00",
                    centiarePrice: "0.00",
                    monthAmount: "0.00"
                });
            },

            editData({row, column}) {
                row[column.property + "isShow"] = true;
                //refreshTable是table数据改动时，刷新table的
                this.refreshTable();
                this.$nextTick(() => {
                    this.$refs[column.property] && this.$refs[column.property].focus();
                });
            },

            alterData(row, column) {
                // console.log(row);
                if (column.property === 'meterRentArea' || column.property === 'centiarePrice' || column.property === 'monthAmount')
                    row[column.property] = (parseFloat(row[column.property] || 0)).toFixed(2);

                row[column.property + "isShow"] = false;
                //refreshTable是table数据改动时，刷新table的
                this.refreshTable();
            },

            refreshTable() {
                this.randomKey = Math.random();
            },

            getLeasorDetail(value) {
                getLeasorDetail({idcard: value}).then(res => {
                    let {
                        info: {
                            name, phone, uuid, leasorType, contactName, contactPhone, idcardValidity, idcardEmblem,
                            idcardFace, businessLicense, companiesSocialCreditCode,subCompanies
                        }
                    } = res;
                    if (uuid) this.contractData.leasorUuid = uuid;
                    if (phone) this.contractData.phone = phone;
                    if (name) this.contractData.name = name;
                    if (leasorType) this.contractData.leasorType = leasorType;
                    if (contactName) this.contractData.contactName = contactName;
                    if (contactPhone) this.contractData.contactPhone = contactPhone;
                    if (idcardValidity) this.contractData.idcardValidity = timeFormat(new Date(idcardValidity));
                    if (idcardEmblem) this.contractData.idcardEmblem = idcardEmblem;
                    if (idcardFace) this.contractData.idcardFace = idcardFace;
                    if (businessLicense) this.contractData.businessLicense = businessLicense;
                    if (companiesSocialCreditCode) this.contractData.companiesSocialCreditCode = companiesSocialCreditCode;
                    if (subCompanies) this.contractData.subCompanies = subCompanies;
                });
            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            numberFormat(number = 0) {
                number = parseFloat(number);
                return numberFormat(number);
            },

            clickCancel() {
                this.apartmentUuids = null;
                this.active = 0;
                this.imgList = [];
                this.depositList = [];
                this.formDepositPublish = {};
                this.depositType = null;
                this.contractData = {
                    uuid: null,
                    shopContractUuid: null,                         //合同uuid
                    leasorUuid: null,                               //租户uuid
                    leasorType: '个人',                               //租户类型 个人 公司
                    idcardFace: null,                               //身份证人像面反面
                    idcardEmblem: null,                             //身份证国徽面正面
                    businessLicense: null,                          //营业执照
                    name: null,                                     //名字
                    idcard: null,                                   //身份证
                    phone: null,                                    //电话号码
                    contactName: null,                              // |string |紧急联系人 |
                    contactPhone: null,                             // |string | 紧急联系人电话 |
                    subCompanies: null,                             //所属公司名称
                    companiesSocialCreditCode: null,                //社会统一信用代码
                    idcardValidity: null,                           //身份证有效期
                    apartmentUuids: null,                           //房间uuid集合
                    biddingUuid: null,                              //竞标记录uuid
                    contractPcNumber: null,                         //管家pc手输合同号
                    startDate: null,                                // 合同开始时间
                    endDate: null,                                  // 合同结束时间
                    signContractDate: null,                         //合同签订时间
                    contractType: null,                             //合同类型 城投自营 、 其他
                    contractTypeName: null,                         //合同类型名称
                    projectRentalType: null,                        //合同中型  1协议出租、2公开竟组、3其他
                    projectRentalTypeName: null,                    //合同中型 名称 协议出租、公开竟组、其他
                    paidBillType: null,                             //缴费方式 微信代扣、线下转账
                    paidBillTypeName: null,                         //缴费方式名称
                    purpose: null,                                  //用途 经营项目
                    rentalDepositMonth: null,                       //履约保证金月数
                    rentalDepositMonthAmount: null,                  //履约保证金月金额
                    rentalDeposit: null,                            //租赁押金
                    hydropowerDeposit: null,                        //水电押金
                    fireDeposit: null,                              //消防押金
                    contractAffiliationType: null,                  //项目归属类型 合同归属
                    contractAffiliationTypeName: null,              //项目归属类型名称 城投自营 其他
                    conductionModeType: null,                       //办理模式
                    conductionModeTypeName: null,                   //办理模式名称 移动端、线下办理
                    shopContractPayBillGrowthRates: [],
                    contractPictures: null,                         //合同照片
                    decorateMonthLength: null,                      //装修月份
                    apartmentSetUuid: null,
                    outArea: null,
                    shopAddress: null,
                    useArea: null,
                    createBillType: null,                           //账单模式类型 1按月 2按季
                    createBillTypeName: null,                       //账单模式类型 按月 按季
                    biddingProjectName: null,
                    biddingDate: null,
                    biddingNumber: null,
                    bidPrice: null,
                };
                this.dialogVisible = false;
            },

            exportContract() {
                let that = this;
                let loadingOptions = that.loadingOptions;
                const loading = that.$loading({...loadingOptions});
                let {uuid} = that.contractData;
                contractExport(uuid).then(res => {
                    downloadByData({data: res, filename: "商铺合同.pdf"});
                    loading.close();
                }).catch(err => loading.close());
            },

            numberBlur(){
                let that = this;
                let {hydropowerDeposit=0,fireDeposit=0,bidPrice=0} = that.contractData;
                that.contractData.hydropowerDeposit = (parseFloat(hydropowerDeposit)).toFixed(2);
                that.contractData.fireDeposit = (parseFloat(fireDeposit)).toFixed(2);
                that.contractData.bidPrice = (parseFloat(bidPrice)).toFixed(2);
            }
        },
        watch: {
            'contractData.rentalDepositMonthAmount'(value) {
                if (value) {
                    let {rentalDepositMonth} = this.contractData;
                    rentalDepositMonth = rentalDepositMonth ? rentalDepositMonth : 0;
                    const honourAgreementBond = parseInt((value * rentalDepositMonth * 100).toFixed(0));
                    this.contractData.rentalDeposit = ParseFloatFormat(honourAgreementBond);
                }
            },
            'contractData.rentalDepositMonth'(value) {
                if (value) {
                    let {rentalDepositMonthAmount} = this.contractData;
                    rentalDepositMonthAmount = rentalDepositMonthAmount ? rentalDepositMonthAmount : 0;
                    const honourAgreementBond = parseInt((value * rentalDepositMonthAmount * 100).toFixed(0));
                    this.contractData.rentalDeposit = ParseFloatFormat(honourAgreementBond);
                }
            },
            'contractData.idcard'(value) {
                if (value && (value.length === 16 || value.length === 18)) {
                    this.getLeasorDetail(value);
                }
            }

        },
    }
</script>

<style lang="scss" scoped>
</style>